module.exports = __webpack_public_path__ + "resources/images/klantenkaarten-26187ea4693b5a14be5fb741f94a192c-cache.jpg";